window.slate = window.slate || {};
window.theme = window.theme || {};

$(document).ready(() => {

// toggle mobile nav in and out
  const $hamburger = $('.js-hamburger');

  $hamburger.on('click', () => {
    $('.js-main-nav').toggleClass('is-open');
  });

// toggle search window open and closed
  $('.main-nav__search, .search__content img').on('click', () => {
    $('.search__overlay').toggleClass('is-visible');
    $('.search__wrapper').toggleClass('is-open');
  });

// set top nav transparency
  if (window.scrollY > 70) {
    $('.js-main-nav').addClass('is-opaque');
  }
  
  window.onscroll = function() {
    if (window.scrollY < 70 && window.location.pathname !== '/cart') {
      $('.js-main-nav').removeClass('is-opaque');
    } else {
      $('.js-main-nav').addClass('is-opaque');
    }
  };

  const selectors = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink',
  };
  
  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }
  
  function checkUrlHash() {
    const hash = window.location.hash;
  
    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }
  
  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }
  
  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    const $formState = $('.reset-password-success');
  
    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }
  
    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
  
  if ($(selectors.recoverPasswordForm).length) {
    checkUrlHash();
    resetPasswordSuccess();
  
    $(selectors.recoverPasswordForm).on('click', onShowHidePasswordForm);
    $(selectors.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);
  }

  const $newAddressForm = $('#AddressNewForm');

if ($newAddressForm.length) {
  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    // new Shopify.CountryProvinceSelector(
    //   'AddressCountryNew',
    //   'AddressProvinceNew',
    //   {
    //     hideElement: 'AddressProvinceContainerNew',
    //   },
    // );
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    const formId = $(this).data('form-id');
    // const countrySelector = `AddressCountry_${formId}`;
    // const provinceSelector = `AddressProvince_${formId}`;
    const containerSelector = `AddressProvinceContainer_${formId}`;

    // new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
    //   hideElement: containerSelector,
    // });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', () => {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    const formId = $(this).data('form-id');
    $(`#EditAddress_${formId}`).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    const $el = $(this);
    const formId = $el.data('form-id');
    const confirmMessage = $el.data('confirm-message');
    if (
      window.confirm(
        confirmMessage || 'Are you sure you wish to delete this address?',
      )
    ) {
      Shopify.postLink(`/account/addresses/${formId}`, {
        parameters: {_method: 'delete'},
      });
    }
  });

}

});
